<template>
    <div class="state">
      <p class="title-2 font">处置状态</p>
      <div class="stateinformation">
        <!-- v-for="(item, index) in warningdetails.handle_people" :key="index" -->
        <div class="stateinformation-box" >
          <ul>
            <!-- <li> <img :src=" this.state > 1 ? require('../assets/images/yuan1.png') : require('../assets/images/yuan2.png')"> <div class="boy"></div></li> -->
            <!-- <li> <img :src=" this.state > 2 ? require('../assets/images/yuan1.png') : require('../assets/images/yuan2.png')"> <div class="boy"></div></li> -->
            <li> 
              <p style="margin-bottom:35px" v-for="(item, i) in 3" :key="i"> <img :src=" 4 > 3 ? require('../assets/images/yuan1.png') : require('../assets/images/yuan2.png')"></p>
              <!-- <p style="border:solid 1px red"> <img :src=" this.state > 3 ? require('../assets/images/yuan1.png') : require('../assets/images/yuan2.png')"></p> -->
             </li>
          </ul>
          <div class="time">
            <div v-for="(item, index) in 3" :key="index">
              <p>{{time}}</p>
              <!-- <p>{{item.alarm_time}}</p> -->
            </div>
          </div>
          <div class="name">
            <div v-for="(item, index) in 3" :key="index">
              <p>张珊（153 2654 4258）（已处置）</p>
              <!-- <p>李流思（153 2654 4258）（已处置）</p>
              <p>王小武（153 2654 4258）（超时）</p> -->
            </div>
          </div>
          <div class="btn">
            <p v-for="(item, index) in 3" :key="index" class="click" @click="urge">催办</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['warningdetails'],
  data () {
    return {
      title: '预警处置',
      state: 4,
      lengths: 1,
      time: '2020-05-20 14:12'
    }
  },
  methods: {
    // 催办
     urge(){
      
     }
  },
  created () {

  }
}
</script>
<style lang='scss' scoped>
  .basic{
    width: 3.51rem;
    margin-top: .23rem;
    font-size: .12rem;
    .title{
      padding-bottom: 0.07rem;
    }
    .basicinformation{
      background-color: #ffff;
      box-shadow:1px 1px 6px 0px rgba(128,128,128,0.6);
      border-radius: .04rem;
      padding: .11rem .13rem .38rem .1rem;
      .row{
        display: flex;
        flex-direction: row;
        p{
          flex: 1;
          text-align: center;
          text-indent: -0.29rem;
          line-height:.29rem;
          font-family:Source Han Sans CN;
          font-weight:400;
          color:rgb(51,51,51);
        }
        div{
          display: flex;
          flex: 1;
          padding-left: .19rem;
          font-family:Source Han Sans CN;
          font-weight:bold;
          color:rgb(255,87,87);
          line-height:.19rem;
          &:nth-of-type(1){
            margin-bottom: .2rem;
          }
        }
        span{
          color:#333333;
          font-family:Source Han Sans CN;
          font-weight:500;
          line-height:.29rem;
          &:nth-last-of-type(1){
            line-height:.19rem;
          }
          &:nth-last-of-type(2){
            line-height: .19rem;
          }
        }
      }
    }
  }
  .state{
    width: 3.51rem;
    margin-top: .16rem;
    .title-2{
      padding-bottom: 0.06rem;
      }
    .stateinformation{
      background-color: #ffff;
      box-shadow:1px 1px 6px 0px rgba(128,128,128,0.6);
      border-radius: .04rem;
      margin-bottom: .12rem;
      .stateinformation-box{
        padding-top: .23rem;
        padding-left: .33rem;
        display: flex;
        flex-direction:row;
        ul{
          li:nth-child(-n+2){
            margin-bottom: .37rem;
          }
          li{
            position: relative;
            div{
                width: .02rem;
                height: .3rem;
                background-color: #009EFF;
                position: absolute;
                top: .14rem;
                left: 0.05rem;
                &::after{
                  content: '';
                  width: 0;
                  height: 0;
                  position: absolute;
                  top: .28rem;
                  right: -0.03rem;
                  border-top: .04rem solid #009EFF;
                  border-left: .04rem solid transparent;
                  border-right: .04rem solid transparent;
                }
              }
            img{
                  width: .12rem;
                  height: .12rem;
                  display: block;
                }
            }
          }
        }
        .time{
          font-size:.1rem;
          font-family:Source Han Sans CN;
          font-weight:400;
          color:rgb(0,158,255);
          line-height:.15rem;
          padding-right: .2rem;
          p{
            white-space:pre-wrap;
            width:.7rem;
            text-align: center;
            padding-bottom: .15rem;
          }
        }
        .name{
          font-size:.1rem;
          font-family:Source Han Sans CN;
          font-weight:400;
          color:rgb(51,51,51,);
          line-height:.15rem;
          p{
            white-space:pre-wrap;
            width:1.4rem;
            text-align: center;
            padding-bottom: .15rem;
          }
        }
      }
      .btn{
        justify-content: center;
        width: 100%;
        line-height:.15rem;
        .click{
          width:.42rem;
          height:.24rem;
          background:rgb(0,158,255);
          border-radius:.12rem;
          text-align: center;
          font-size:.12rem;
          font-family:Source Han Sans CN;
          font-weight:500;
          color:rgba(254,254,254,1);
          line-height:.24rem;
          margin-bottom: .15rem;
        }
      }
    }
</style>
